import type { ContractPaymentsFilterInputType } from "@/types/graphql/partner.generated";
import { toIsoDate } from "@/partner/shared/utils/filterValues";
import { CONTRACT_PAYMENT_STATUSES } from "./paymentStatus";

/**
 * Значения фильтра из querystring в аргумент `contractPayments(filter:)`.
 * `dateFrom`/`dateTo`: общие поля компонента `Filter`, на бэкенде у счёта
 * это `invoiceDateFrom`/`invoiceDateTo` (спека, «дата счёта», а не период
 * оказания услуг). Пустой результат отдаётся как `undefined`, приём
 * из `buildPaymentsFilter`.
 */
export function buildInvoicesFilter(
  filter: Record<string, unknown>
): ContractPaymentsFilterInputType | undefined {
  const result: ContractPaymentsFilterInputType = {};

  if (
    typeof filter.status === "string" &&
    (CONTRACT_PAYMENT_STATUSES as readonly string[]).includes(filter.status)
  ) {
    result.status = filter.status;
  }

  const invoiceDateFrom = toIsoDate(filter.dateFrom);
  if (invoiceDateFrom) result.invoiceDateFrom = invoiceDateFrom;

  const invoiceDateTo = toIsoDate(filter.dateTo);
  if (invoiceDateTo) result.invoiceDateTo = invoiceDateTo;

  return Object.keys(result).length > 0 ? result : undefined;
}
